import { helpers } from 'vuelidate/lib/validators'
import { Notify } from 'quasar'

export const alphaWithSpace = helpers.regex('alphaWithSpace', /^[a-zA-Z\s]*$/)

export function validateSize (fileSize, maxFileSize = 30) {
  const _maximalFileSize = parseFloat(maxFileSize) * 1e6
  if (fileSize < _maximalFileSize) return true
  else {
    Notify.create({
      message: `Hanya menerima file dengan ukuran maksimal ${maxFileSize}MB`,
      color: 'negative'
    })

    return false
  }
}

export const serverValidation = key => helpers.withParams({ type: 'serverValidation' }, function (value) {
  return key in this?.serverValidationErrors === false
})
